<button 
    size="small" 
    p-button  
    [pTooltip]="data.length > 0 ? tooltipContent : ''" 
    tooltipPosition="bottom" 
    class="ml-3 split-button-orange-1" 
    [class.active]="data.length > 0" 
    type="button" 
    (click)="showOverlayPanel($event)">
    {{label}}
</button>
<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <div class="split-calendar-panel flex w-full">
        <p-calendar view="year" dateFormat="yy" (click)="$event.stopPropagation()" [(ngModel)]="_data" class="w-full" [inline]="true" >
            <ng-template pTemplate="footer">
                <div class="flex justify-content-between mt-3">
                    <p-button (click)="onCancel()" label="cancelar" [outlined]="true"  severity="secondary"></p-button>
                    <p-button (click)="onEmit()" label="aplicar"></p-button>
                </div>
            </ng-template>
        </p-calendar>
    </div>
</p-overlayPanel>

<ng-template #tooltipContent>
   <p class="my-1">Filtros selecionados: </p>
   <div class="flex align-items-center justify-content-center">
        <span>{{_data | date:'yyyy'}}</span>
   </div>
</ng-template>